import { useMutation, useQuery, useReactiveVar } from "@apollo/client";
import { LocationGenerics } from "router/location";
import { Modal } from "components/layouts";
import {  useSearch } from "react-location";
import {
  APPROVE_ISSUE_RESOLUTION,
  GET_ISSUE,
} from "./apollo";
import { currentUserVar } from "apollo/cache/auth";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import { IssueSummaryForm } from "components/forms/issue-summary";

export default function ApproveIssueContainer({
  open,
  setOpen,
  refetch
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch: any
}) {
  const searchParams = useSearch<LocationGenerics>();
  const currentUser = useReactiveVar(currentUserVar);

  const { data, loading } = useQuery(GET_ISSUE, {
    variables: {
      id: searchParams.id,
    },
    notifyOnNetworkStatusChange: false,
    fetchPolicy: "network-only",
  });

  const [completeIssue] = useMutation(APPROVE_ISSUE_RESOLUTION);

  const form = useFormik<any>({
    initialValues: {
      notes: "",
    },
    onSubmit: async (values) => {
      await completeIssue({
        variables: {
          id: searchParams.id,
          ...values,
        },
      }).then(({ data }) => {
        if (data.completeIssue._id) {
          toast(
            JSON.stringify({
              type: "success",
              title: "Issue Resolution Approved Successfully",
            })
          );
          form.resetForm();
          refetch?.()
        } else {
          toast(
            JSON.stringify({
              type: "error",
              title: "Unable to approve issue resolution",
            })
          );
        }
      });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      hidePadding
      title="Approve Issue Resolution"
      size="4xl"
      description="Approve this Issue resolution"
      renderActions={() => (
        <>
          {data?.issue?.createdBy === currentUser?._id &&
            ["Resolved", "EscalatedToPolymorphLabs"].includes(data?.issue?.currentStage.stage) && (
              <button
                type="button"
                className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
                onClick={form.submitForm}
              >
                {form.isSubmitting
                  ? "Approving Issue Resolution..."
                  : "Approve Issue Resolution"}
              </button>
            )}
        </>
      )}
    >
      {data?.issue?._id && (
        <IssueSummaryForm issue={data?.issue} form={form} />
      )}
    </Modal>
  );
}
